import axios from 'axios';
import Vuex from 'vuex';

import categories from './store/categories';
import main from './store/main';
import counter from './store/counter';
import catalog_action from './store/catalog_action';
import products from './store/products';
import filter from './store/filter';
import product from './store/product';
import products_style from './store/products_style';
import products_similar from './store/products_similar';
import products_viewed from './store/products_viewed';
import boutiques from './store/boutiques';
import product_store from './store/product_store';
import basket from './store/basket';
import order from './store/order';
import blog from './store/blog';
import blog_detail from './store/blog_detail';
import push from './store/push';
import certificate from './store/certificate';
import favorite from './store/favorite';
import promocode from './store/promocode';
import search_title from './store/search_title';
import pickup_point from './store/pickup_point';
import page from './store/page';
import bonus from './store/bonus';
import waiting from './store/waiting';
import address from './store/address';
import orders from './store/orders';
import order_detail from './store/order_detail';
import loyalty from './store/loyalty';
import gender from './store/gender';
import brand from './store/brand';
import historybuy from './store/historybuy';
import historybuy_detail from './store/historybuy_detail';

export default new Vuex.Store({
    state: {
        isAuth: false,
        user: {},
        uuid: '',
        device: '',
        device_uuid: '',
        errorRequest: false,
        error: false
    },
    mutations: {
        Auth(state, data) {
            state.device = data.device;
            state.device_uuid = data.uuid;
            if (data.ID) {
                state.isAuth = true;
                //localStorage.setItem('user-token', data.token);
                state.user = {
                    admin: data.ADMIN,
                    name: data.NAME,
                    last_name: data.LAST_NAME,
                    second_name: data.SECOND_NAME,
                    phone: data.PHONE,
                    email: data.EMAIL,
                    day: data.PERSONAL_BIRTHDAY?parseInt(data.PERSONAL_BIRTHDAY.split('.')[0]):'',
                    month: data.PERSONAL_BIRTHDAY?parseInt(data.PERSONAL_BIRTHDAY.split('.')[1]):'',
                    year: data.PERSONAL_BIRTHDAY?parseInt(data.PERSONAL_BIRTHDAY.split('.')[2]):'',
                    birthday: data.PERSONAL_BIRTHDAY
                }
            }
        },
        Uuid(state, data) {
            state.uuid = data
        },
        logout(state) {
            state.isAuth = false;
            //localStorage.setItem('user-token', data.token);
            state.user = {}
        },
        setError(state, data) {
            state.errorRequest = true;
            state.error = data;
        }
    },
    actions: {
        async Auth({commit, dispatch}, data) {
            commit('Auth', data);
            dispatch('fetchBonus');
            dispatch('fetchCounterData');
            try {
                if (typeof window.FirebasePlugin != 'undefined') {
                    if (!window.FirebasePlugin.hasPermission()) {
                        window.FirebasePlugin.grantPermission(function () {
                            window.FirebasePlugin.getToken(async function (device_token) {
                                axios.post('api/token/', {
                                    uuid: data.uuid,
                                    token: device_token,
                                    device: data.device
                                });
                            }, function (error) {
                                //alert('error')
                            });
                        }, function (error) {
                            //alert(error);
                        });
                    }
                    window.FirebasePlugin.getToken(async function (device_token) {
                        axios.post('api/token/', {
                            uuid: data.uuid,
                            token: device_token,
                            device: data.device
                        },{
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }});
                    }, function (error) {
                        //alert('error')
                    });
                }
            }
            catch (err) {
                let form = new FormData();
                form.append("useragent", window.navigator.userAgent)
                form.append("date", new Date());
                form.append("error", err);
                /*let response = fetch('https://mcbuy.mobileapp.alm.su/api/log/', {
                    method: 'POST',
                    body: form
                });*/
                axios.post('api/log/', form,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }});
            }
        },

        AuthRepeat({commit, dispatch}, data) {
            commit('Auth', data);
        },
        async logout({commit, dispatch, state}) {
            await axios.post('api/user/logout/', {uuid: state.device_uuid},
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            commit('logout');
        },
        async setError({commit, dispatch}, data) {
            commit('setError', data);
        }
    },
    getters: {
        isAuth: s => s.isAuth,
        device_uuid: s => s.device_uuid,
        device: s => s.device,
        user: s => s.user,
        errorRequest: s => s.errorRequest
    },
    modules: {
        categories,
        main,
        counter,
        catalog_action,
        products,
        filter,
        product,
        products_style,
        products_similar,
        products_viewed,
        boutiques,
        product_store,
        basket,
        order,
        blog,
        blog_detail,
        push,
        certificate,
        favorite,
        promocode,
        search_title,
        pickup_point,
        page,
        bonus,
        waiting,
        address,
        orders,
        order_detail,
        loyalty,
        gender,
        brand,
        historybuy,
        historybuy_detail
    }
})
